<template>
  <!-- 标题 高级筛选 -->
  <div class="bg-shadow flex-wrap el-tabs__content">
    <!--  -->
    <!-- 重要指标 -->
    <index-common v-if="page.isIndex"
                  v-loading="loading.indexLoading"
                  element-loading-background="#FFF"
                  element-loading-spinner="el-icon-loading"
                  element-loading-customClass="defineLoading"
                  element-loading-text="拼命的加载中"
                  class="block-preview noCompare_min"
                  :options="summaryList">
    </index-common>
    <!-- 趋势图 -->
    <chart-content :flod="flod"
                   v-if="page.isChart">
      <div class="flex-between gragh-index">
        <!-- 图的指标 -->
        <component :is="page.selectChart"
                   :class-key="page.chartKey"
                   :number="page.chartNum"
                   :indicator="page.indicator"
                   :address="page.chartAddress">
        </component>
        <!-- 按日等标签 -->
        <div v-if="page.isTime">
          <el-radio-group v-model="tabPosition">
            <el-radio-button label="byDay"
                             v-if="page.isDay">按日</el-radio-button>
            <el-radio-button :disabled=disabled[0]
                             label="byWeek">按周</el-radio-button>
            <el-radio-button :disabled=disabled[1]
                             label="byMonth">按月</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <!-- 2个图 -->
      <div v-if="page.isTwo"
           :class="bigClass">
        <component v-if="!queryCommon.compareType"
                   :is="page.firstChart"
                   id="chart"
                   :style="firstClass"
                   v-loading="loading.pieLoading1"
                   element-loading-background="#FFF"
                   element-loading-spinner="el-icon-loading"
                   element-loading-customClass="defineLoading"
                   element-loading-text="拼命的加载中"
                   :options="option1"></component>
        <component v-if="!queryCommon.compareType"
                   :is="page.secondChart"
                   id="chart"
                   :style="secondClass"
                   v-loading="loading.chartLoading1"
                   element-loading-background="#FFF"
                   element-loading-spinner="el-icon-loading"
                   element-loading-customClass="defineLoading"
                   element-loading-text="拼命的加载中"
                   :options="option2"
                   tag=1
                   :show="loading.chartLoading1"></component>
        <component v-if="queryCommon.compareType"
                   :is="page.compareChart"
                   id="chart2"
                   style="flex:1"
                   v-loading="loading.pieLoading2"
                   element-loading-background="#FFF"
                   element-loading-spinner="el-icon-loading"
                   element-loading-customClass="defineLoading"
                   element-loading-text="拼命的加载中"
                   :options="option3"></component>
        <component v-if="queryCommon.compareType"
                   :is="page.compareChart"
                   style="flex:1"
                   v-loading="loading.pieLoading3"
                   element-loading-background="#FFF"
                   element-loading-spinner="el-icon-loading"
                   element-loading-customClass="defineLoading"
                   element-loading-text="拼命的加载中"
                   :options="option4"></component>
      </div>
      <!-- 1个图 -->
      <component v-if="!page.isTwo"
                 :is="page.oneChart"
                 id="chart"
                 v-loading="loading.chartLoading"
                 element-loading-background="#FFF"
                 element-loading-spinner="el-icon-loading"
                 element-loading-customClass="defineLoading"
                 element-loading-text="拼命的加载中"
                 :options="option5"
                 :show="loading.chartLoading">
      </component>
    </chart-content>

    <!-- 自定义指标、表格 -->
    <div style="position: relative"
         :class="page.isChart?'width-full padding-bottom-md':'graph-table'"
         v-if="page.isTable">
      <zoom @zoom="changeflod"
            v-if="page.chartZoom"></zoom>
      <!-- 表的指标 -->
      <component :is="page.selectTable"
                 :class-key="page.tableKey"
                 :number="page.tableNum"
                 :address="page.tableAddress">
      </component>
      <div class="table_min"
           v-if="page.isTableKey"
           v-loading="loading.tableLoading"
           element-loading-background="#FFF"
           element-loading-spinner="el-icon-loading"
           element-loading-customClass="defineLoading"
           element-loading-text="拼命的加载中">
        <component v-if="!queryCommon.compareType"
                   :title="page.tableTitle"
                   :is="page.normalTable"
                   :tableInfo="tableInfo"
                   :devsort-style="tableInfo.devsort"
                   :focus="page.focus"
                   :queryKey="queryKey">
        </component>
        <component v-if="queryCommon.compareType"
                   :title="page.tableTitle"
                   :is="page.compareTable"
                   :tableInfo="tableInfo"
                   :devsort-style="tableInfo.devsort">
        </component>
      </div>
    </div>
  </div>

</template>

<script>
import * as queryUtil from "../../../common/query";
import * as util from "../../../common/util";
import * as Func from "../../../common/commonFun";
import { content } from "./component";
import _ from 'lodash'
const log = console.log.bind(console)
export default {
  components: {
    ...content
  },
  props: {
    page: [Object],
    headerVal: [Object],
    header: [Object],
    queryKey: [String],
    headerShow: [Array]
  },
  data() {
    return {
      loading: {
        indexLoading: false,
        pieLoading: false,
        pieLoading1: false,
        chartLoading: false,
        chartLoading1: false,
        tableLoading: false,
        pieLoading2: false,
        pieLoading3: false
      },
      query: {},
      // 表格
      tableInfo: {},
      // 指标
      summaryList: [],
      // 按周
      tabPosition: "",
      disabled: [false, false],
      flod: false,
      option1: {},
      option2: {},
      option3: {},
      option4: {},
      option5: {},
      limitNum: "1",
      pageNum: 1,
      weekShow: true,
      secondClass: "",
      firstClass: "",
      pie1Data: [],
      twoPieName: []
    };
  },
  created() {
    this.limitNum = this.page.chartNum;
    if (this.headerVal !== undefined && Object.keys(this.headerVal).length) {
      this.changeHeader(this.headerVal.time);
    }
    // 项目分类，刚开始为一个饼图，点击下钻时为2个
    if (this.page.firstChart === this.page.secondChart) {
      this.secondClass = "";
      this.firstClass = "flex:1";
      this.bigClass = "flex-nowrap flex-center-center";
    } else {
      if(this.page.firstChart === 'Funnel' && this.page.secondChart === 'AsideTrend'){
        // 漏斗图+趋势
        this.firstClass = "width: 50%!important; position:relative";
        this.secondClass = "width: 50%; position:relative";
        this.bigClass = "flex-nowrap pie-spine flex-main-start";
      }else{
        // 饼图+趋势
        this.firstClass = "";
        this.secondClass = "width: 70%; position:relative";
        this.bigClass = "flex-nowrap pie-spine flex-main-start";
      }
    }
    if (this.page.isChart) {
      if (this.page.isTime) {
        // 没有日
        if (!this.page.isDay) {
          this.tabPosition = "byWeek";
          if (
            this.header.quckTime === "TimeTab" ||
            this.header.quckTime === "MonthTabTwo" ||
            this.header.quckTime === "MonthTabThree"
          ) {
            this.disabled = [false, true];
          }
        } else {
          // 有日
          // 上周
          if (this.header.quckTime === "TimeTab") {
            this.disabled = [true, true];
          } else if (this.header.quckTime === "MonthTabTwo") {
            // 上月
            this.disabled = [false, true];
          }
          this.tabPosition = "byDay";
        }
      }
    }
    // 版本2，表格也要传byWhichWay
    if (this.page.tableTitle === "日期") {
      this.tabPosition = this.page.byWhichWay;
      queryUtil.setQueryTable({ byWhichWay: this.tabPosition });
    }

    // 判断是否是微信
    if(['funnel_transfer_wxbook_funnel_drawing','funnel_transfer_telphonebook_funnel_drawing'].includes(this.page.chartKey)){
      queryUtil.setQuery({ bookSource: this.page.bookSource });
    }
    console.log()
  },
  computed: {
    // 下钻饼图的pieIndex
    pieIndex() {
      return this.$store.state.pieIndex;
    },
    // 公共数据
    queryCommon() {
      // 对比时只能选择一个
      if (this.$store.state.query_common.compareType) {
        this.page.chartNum = "1";
      } else {
        this.page.chartNum = this.limitNum;
      }
      return this.$store.state.query_common;
    },
    queryTable() {
      console.log(this.$store.state.query_common ,this.$store.state.query_table , 'this.$store.state.query_table')
      return Object.assign(
        {},
        this.$store.state.query_common,
        this.$store.state.query_table,
        // {bookSource: (this.page.bookSource || this.page.bookSource === 0) ? this.page.bookSource : -1}
      );
    },
    queryIndex() {
      return Object.assign(
        {},
        this.$store.state.query_common,
        this.$store.state.query_table,
        // {bookSource: (this.page.bookSource || this.page.bookSource === 0) ? this.page.bookSource : -1}
      );
    },
    queryPie() {
      return Object.assign(
        {},
        this.$store.state.query_data,
        this.$store.state.query_common,
        // {bookSource: (this.page.bookSource || this.page.bookSource === 0) ? this.page.bookSource : -1}
      );
    },
    queryFunnel(v) {
        // 切换其他页面，pie的监听会出发，所以禁止调用pie接口
        return Object.assign(
            {},
            this.$store.state.query_data,
            this.$store.state.query_common,
            // {bookSource: (this.page.bookSource || this.page.bookSource === 0) ? this.page.bookSource : -1}
        )
    },
    queryChart() {
      return Object.assign(
        {},
        this.$store.state.query_data,
        this.$store.state.query_common,
        {
          byWhichWay: this.tabPosition
        },
        // {bookSource: (this.page.bookSource || this.page.bookSource === 0) ? this.page.bookSource : -1}
      );
    },
    queryPieData() {
      if (this.$store.state.pieIndex.index === "") {
        return "";
      } else {
        return this.pie1Data[this.$store.state.pieIndex.index];
      }
    }
  },
  watch: {

    //测试
    tableInfo(v) {
      console.log("table表格数据改变",v)
    },
    queryTable(v) {
      this.getTable(v);
    },
    queryIndex(v) {
      this.getIndex(v);
    },
    queryPie(v) {
      if (this.page.isTwo) {
        this.getChartPie(v);
      }
    },
    queryFunnel(v) {
      // 切换其他页面，pie的监听会出发，所以禁止调用pie接口
      if (this.page.isTwo && v.constantKey) {
          this.getChartFunnel(v)
      }
    },

    queryChart(v) {
      this.getChart(v);
    },
    queryPieData(v) {
      this.getDeepPie(v);
    },
    "headerVal.time": {
      deep: true, // 深度监听设置为 true
      handler: function(newV) {
        this.changeHeader(newV);
      }
    },
    pieIndex(v) {
      if (v.index !== "") {
        this.secondClass = "flex:1";
      }
    }
  },
  methods: {
    // 关键指标
    getIndex(params) {
      // 活动,优惠券等模块，没有选中活动，则拦截请求
      if (this.page.needDiscountID) {
        if (params.discountID === undefined) return;
      }
      if (
        this.$route.name === this.page.name &&
        Object.keys(params).indexOf("indicatorIDs") >= 0
      ) {
        queryUtil.changeParams(
          this.headerShow,
          params,
          this.page.tableTitle,
          this.header.contrast
        );
        queryUtil.changeIndexParams(params);
        params.constantType = this.page.TableconstantType;
        // 增长里面 关键指标为对比形式，所以选传IndexCompareType为1，单独请求
        if(this.page.firstChart === 'Funnel' && ['funnel_transfer_wxbook_funnel_drawing','funnel_transfer_telphonebook_funnel_drawing' ].includes(this.page.chartKey)){
          params.bookSource = this.page.bookSource
        }else{
          params.bookSource = params.bookSource ? params.bookSource : undefined
        }
        if (this.page.isIndex && this.page.IndexCompareType !== undefined) {
          let a = params;
          a.compareType = this.page.IndexCompareType;
          Func.getIndexTwo(this, a);
        } else {
          // 特殊情况，新会员来源分析页面表头没有会员，但是要传isOld字段
          if (this.$route.name === "cust_newMembers") {
            params.isOld = 0;
          }
          // 正常情况
          Func.getIndexTwo(this, params);
        }
      }
    },
    // 查询表格和重要指标
    getTable(params) {
        log('get Table')
      // 活动,优惠券等模块，没有选中活动，则拦截请求
      if (this.page.needDiscountID) {
        if (params.discountID === undefined) return;
      }
      // 正常的有关键指标，也有图表
      if (
        this.$route.name === this.page.name &&
        Object.keys(params).indexOf("indicatorIDs") >= 0 &&
        this.page.isTableKey
      ) {
        queryUtil.changeParams(
          this.headerShow,
          params,
          this.page.tableTitle,
          this.header.contrast
        );
        params.constantType = this.page.TableconstantType;
        // 特殊情况，新会员来源分析页面表头没有会员，但是要传isOld字段
        if (this.$route.name === "cust_newMembers") {
          params.isOld = 0;
        }
        if (this.page.normalTable === "ColorTable") {
            let title = this.page.tableTitle
            // log('title is', title)
            let list = ['活动名称', '优惠券名称', '积分商品名称']
            if (list.includes(title)) {
                params.sortIndex -= 1
                log(`title is (${title}), sorIndex = (${params.sortIndex})`)
            }
          Func.getColorTableTwo(this, params);
        } else if (
          this.page.normalTable === "OneTable" &&
          !this.queryCommon.compareType
        ) {
          Func.getOneTableTwo(this, params);
        } else if (
          this.page.normalTable === "ContrantTable" ||
          this.page.normalTable === "ContrantOneTable"
        ) {
          console.log('method getContastTableTwo')
          Func.getContastTableTwo(this, params);
        } else if (this.page.normalTable === "DateTable") {
          console.log('method getDateTableTwo1111',params)
          Func.getDateTableTwo(this, params);
        } else if (
          this.page.compareTable === "ContrantTable" &&
          this.queryCommon.compareType
        ) {
          console.log('method  getContastTableThird')
          Func.getContastTableThird(this, params);
        } else if (
          this.page.normalTable === "OneLevel" ||
          (this.page.compareTable === "OneLevel" &&
            this.queryCommon.compareType)
        ) {
          console.log('--------')
          Func.getOneLevelTwo(this, params);
        } else if (this.page.normalTable === "TableCard") {
          if(this.page.firstChart === 'Funnel' && ['funnel_transfer_wxbook_funnel_drawing','funnel_transfer_telphonebook_funnel_drawing' ].includes(this.page.chartKey)){
            params.bookSource = this.page.bookSource
          }else{
            params.bookSource = params.bookSource ? params.bookSource : undefined
          }
          Func.getTableCardTwo(this, params);
        } else if (this.page.normalTable === "AreaTable") {
          Func.getAreaTableTwo(this, params);
        } else if (this.page.normalTable === "TableAnalysis") {
          Func.getAnalysisTableTwo(this, params);
        } else if (this.page.normalTable === "RetainTable") {
          Func.getRetainTable(this, params);
        } else if (this.page.normalTable === "noDimensionTable") {
          Func.getNoDimensionTable(this, params);
        }
      }
    },
    // 查询chart
    getChart(params) {
      // 活动,优惠券等模块，没有选中活动，则拦截请求
      if (this.page.needDiscountID) {
        if (params.discountID === undefined) return;
      }
      if (
        this.$route.name === this.page.name &&
        Object.keys(params).indexOf("indicatorIDs") >= 0
      ) {
        queryUtil.changeParams(
          this.headerShow,
          params,
          this.page.tableTitle,
          this.header.contrast
        );
        queryUtil.changeTrendParams(params);
        params.constantType = this.page.ChartconstantType;
        // 特殊情况，新会员来源分析页面表头没有会员，但是要传isOld字段
        if (this.$route.name === "cust_newMembers") {
          params.isOld = 0;
        }
        console.log("this.page.oneChart=>",this.page.oneChart);
        console.log(this.page,'this.page')
        if(this.page.firstChart === 'Funnel' && ['funnel_transfer_wxbook_funnel_drawing','funnel_transfer_telphonebook_funnel_drawing' ].includes(this.page.chartKey)){
          params.bookSource = this.page.bookSource
        }else{
          params.bookSource = params.bookSource ? params.bookSource : undefined
        }
        if (this.page.oneChart === "VueHighchart") {
          console.log("this.page.ChartconstantType=>",this.page.ChartconstantType)
          if (this.page.ChartconstantType === 3) {
            // 同比环比趋势图
            Func.getTrendThird(this, params);
          } else if (this.page.ChartconstantType === 4) {
            // 双维度趋势图
            Func.getTrendTwo(this, params);
          } else {
            // 正常的趋势图
            Func.getTrendOne(this, params);
          }
        } else if (
          this.page.secondChart === "AsideTrend" &&
          this.page.oneChart === ""
        ) {
          // 饼图+趋势图的趋势图
          Func.getTwoTrend(this, params);
        } else if (this.page.oneChart === "VueColumn") {
           console.log("VueColumn=>",this.page.ChartconstantType)
          if (this.page.ChartconstantType === 3) {
            // 不排序的柱状图
            Func.getCloumnThird(this, params);
          } else if (this.page.ChartconstantType === 4) {
            // 不排序的柱状图
            Func.getCloumnTwo(this, params);
          } else {
            if (!this.page.isFilter) {
              if (this.page.chartSort) {
                // 排序的柱状图
                Func.getSortCloumnOne(this, params);
              } else {
                // 不排序的柱状图
                Func.getCloumnOne(this, params);
              }
            } else {
              if (this.page.chartSort) {
                // 排序的柱状图
                Func.getSortCloumnThree(this, params);
              }
            }
          }
        } else if (this.page.oneChart === "VueColumnThree") {
          if (this.page.chartSort) {
            // 排序的柱状图
            Func.getSortCloumnThree(this, params);
          }
        } else if (this.page.oneChart === "ChartHeatmap") {
          // 热力图
          params.constantKeyAxis = this.page.constantKeyAxis;
          Func.getHeatmap(this, params);
        } else if (this.page.oneChart === "Sangkey") {
          // 桑基图
          Func.getSangkey(this, params);
        }
        if (this.page.oneChart === "Funnel") {
          // 桑基图
          Func.getFunnel(this, params);
        }
      }
    },
    getChartFunnel: _.debounce(function (params){
      if (this.page.firstChart === 'Funnel') {
            console.log(params,'params');
            Func.getFunnelTwoTrend(this, params)
        }
    } , 500),
    getChartPie(params) {
      if (this.page.needDiscountID) {
        if (params.discountID === undefined) return;
      }
      if (
        this.$route.name === this.page.name &&
        Object.keys(params).indexOf("indicatorIDs") >= 0
      ) {
        queryUtil.changeParams(
          this.headerShow,
          params,
          this.page.tableTitle,
          this.header.contrast
        );
        queryUtil.changeTrendParams(params);
        params.constantType = this.page.PieconstantType;
        // 饼图+趋势图的饼图
        if (
          this.page.firstChart === "VuePie" &&
          this.page.secondChart !== "VuePie"
        ) {
          // console.log(params);
          Func.getPieTwo(this, params);
        } else if (
          this.page.firstChart === "VuePie" &&
          this.page.secondChart === "VuePie"
        ) {
          // 带下钻的饼图，不对比的饼图1和对比是的2个饼图1
          Func.getOnePieTwo(this, params);
        }
      }
    },
    // 下钻的饼图2
    getDeepPie(params) {
      if (
        params !== undefined &&
        params !== "" &&
        !this.queryCommon.compareType
      ) {
        let a = {};
        if (this.queryKey === "categoryID") {
          a = {
            categoryID: params.valueOrID,
            constantType: this.page.PieconstantType,
            type: 3
          };
        } else if (this.queryKey === "timeLength") {
          a = {
            timeLength: params.valueOrID,
            constantType: this.page.PieconstantType,
            type: 3
          };
        } else if (this.queryKey === "price") {
          let miniPrice = 0;
          let maxPrice = 0;
          switch (params.name) {
            case "小于300元":
              miniPrice = 0;
              maxPrice = 300;
              break;
            case "大于800":
              miniPrice = 800;
              maxPrice = 0;
              break;
            default:
              let c = params.name.split("-");
              let d = c[1].split("元");
              miniPrice = parseInt(c[0]);
              maxPrice = parseInt(d[0]);
              break;
          }
          a = {
            miniPrice: miniPrice,
            maxPrice: maxPrice,
            constantType: 8,
            type: 3
          };
        } else if (this.queryKey === "npsType") {
          a = {
            parentID: params.valueOrID,
            constantType: this.page.PieconstantType,
            type: 3
          };
        } else {
          a = {
            status: params.valueOrID,
            constantType: this.page.PieconstantType,
            type: 3,
            constantKey: "coupon_status_pie_two_dimension"
          };
        }
        // 不能直接改this.queryCommon，要不然第一个饼图会重新获取
        // this.queryCommon.categoryID=params.valueOrID
        // this.queryCommon.constantType=this.page.PieconstantType
        let arg = Object.assign(
          {},
          this.queryCommon,
          this.$store.state.query_data,
          a
        );
        queryUtil.changeParams(
          this.headerShow,
          arg,
          this.page.tableTitle,
          this.header.contrast
        );
        queryUtil.changeTrendParams(arg);
        Func.getDeepPieTwo(this, arg);
      }
    },
    change_header(val) {
      let tab = util.byWatch(val, this.tabPosition);
      tab.disabled.forEach((item, index) => {
        this.disabled.splice(index, 1, item);
      });
      this.tabPosition = tab.tabPosition;
      this.disabled = [true, true];
    },
    changeflod(val) {
      this.flod = val;
    },
    // 表头时间改变，改变按日，按周，按月的选择禁用
    changeHeader(val) {
      let timeBlock = util.report.timeinterval(val);
      this.disabled = [true, true];
      // 按周
      if (timeBlock >= 8 && timeBlock < 32) {
        this.disabled.splice(0, 1, false);
      } else if (timeBlock >= 32) {
        // 按月
        this.disabled.splice(0, 2, false);
      } else {
        // 按日
        if (this.page.isDay) {
          this.tabPosition = "byDay";
        } else {
          this.disabled.splice(0, 1, false);
          this.tabPosition = "byWeek";
        }
      }
    }
  }
};
</script>

<style lang="less">
</style>
